<template>
  <div></div>
</template>
<script>
// import swal from 'sweetalert'
import axios from "axios";

export default {
  data() {
    return {};
  },
  created() {
    this.checkUserid();
  },
  mounted() {},
  methods: {
    checkUserid() {
      let login_href = window.location.href;
      let token = localStorage.getItem("access_token");
      if (!!token && token != "undefined") {
      } else {
        let code = this.getParameterByName("code");
        // let source = sessionStorage.getItem('source')
        let source = "";
        let source1 = this.getSourceByName("source");
        if (source1 != sessionStorage.getItem("source")) {
          sessionStorage.removeItem("source");
          sessionStorage.setItem("source", source1);
          source = source1;
        } else {
          source = sessionStorage.getItem("source");
        }
        console.log("source1", source1);

        if (!code) {
          //跳转授权页
          // window.location.href =
          //   'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx312d0cdc770395b9&redirect_uri=' +
          //   encodeURIComponent(login_href) +
          //   '&response_type=code&scope=snsapi_userinfo&state=antservice#wechat_redirect';
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8463e104638e43bd&redirect_uri=" +
            encodeURIComponent(login_href) +
            "&response_type=code&scope=snsapi_userinfo&state=Lailai#wechat_redirect";
          //window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx844fbb6287eb1066&redirect_uri=' + encodeURIComponent(login_href) + '&response_type=code&scope=snsapi_userinfo&state=linkces#wechat_redirect';
        } else {
          console.log("code", code);
          var url =
            "https://w.llchefu.com/wechat/user/access-token?code=" + code;
          //var url = 'https://wechat.youxiangchewang.com/wechat/user/access-token?code='+ code;
          // var url = 'https://antwechat.yqhinfo.com/wechat/user/access-token?code=' + code;
          //var url = 'https://wechat.linkces.com/wechat/user/access-token?code='+ code;
          url = !source ? url : url + "&source=" + source;
          // let url = !source ? "'https://wechat.linkces.com/wechat/user/access-token?code='+ code " : "'https://wechat.linkces.com/wechat/user/access-token?code=' + code'&source='+source"
          axios.get(url).then(function(res) {
            if (res.data.code == 0) {
              console.log("access_token:", res.data.data.access_token);
              localStorage.setItem("userinfo", JSON.stringify(res.data.data));
              localStorage.setItem("access_token", res.data.data.access_token);
              localStorage.setItem("mobile", res.data.data.mobile);
              let last_location_href = localStorage.getItem(
                "last_location_href"
              );
              // console.log('进来前的页面路径2', last_location_href)
              if (last_location_href) {
                localStorage.removeItem("last_location_href"); //移除缓存再跳转
                window.location.href = last_location_href;
              } else {
                window.location.href = "https://m.llchefu.com/";
                // window.location.href = "https://antm.yqhinfo.com"
                //window.location.href = "https://m.linkces.com"
              }
            } else {
              this.$toast({
                message: "登录失败,请重试"
              });
            }
          });
        }
      }
    },
    getParameterByName(name) {
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(window.location.search);
      if (results == null) {
        return "";
      } else {
        return decodeURIComponent(results[1].replace(/\+/g, " "));
      }
    },
    getSourceByName(name) {
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(window.location.search);
      if (results == null) {
        return "";
      } else {
        return decodeURIComponent(results[1].replace(/\+/g, " "));
      }
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/login/login.vue